import { z } from "zod";
import { ZDate } from "../ZDate.js";
import { MessageSpec, VoidMessageSpec } from "./MessageProcessor.js";
import { Notification, SignInKey } from "./messageTypeSchemas.js";
export const DataSendStartArgs = z.object({
    plantIds: z.array(z.number()),
    sensorIds: z.array(z.number()),
    interval: z.object({
        gte: ZDate,
        lt: ZDate
    })
});
export const DataBatchArgs = z.object({
    progressPercentage: z.number(),
    lines: z.array(z.string())
});
export const messageTypes = {
    notification: new MessageSpec(Notification),
    reload: new VoidMessageSpec(),
    resetCBMData: new VoidMessageSpec(),
    resetFuelBaselines: new VoidMessageSpec(),
    resetOpModeFuelConsumption: new VoidMessageSpec(),
    resetPlantFuelConsumed: new VoidMessageSpec(),
    serverStopping: new VoidMessageSpec(),
    signIn: new MessageSpec(SignInKey),
    dataSendStart: new MessageSpec(DataSendStartArgs),
    dataSendStop: new VoidMessageSpec(),
    dataBatch: new MessageSpec(DataBatchArgs),
};
{
    for (const [key, value] of Object.entries(messageTypes)) {
        value.name = key;
    }
}
//# sourceMappingURL=messageTypes.js.map